import { createReducer } from "@reduxjs/toolkit";
import { GetHistory, GetHistoryItems, GetSOHistory, GetSQHistory, PrintReport } from "./HistoryThunk";



const handleAsyncActions = (builder, action, dataKey, errorKey) => {
    builder
        .addCase(action.pending, (state) => {
            state.loading[dataKey] = true;
            state[dataKey] = null;
            state.error[errorKey] = null;
        })
        .addCase(action.fulfilled, (state, action) => {
            state.loading[dataKey] = false;
            state[dataKey] = action.payload;
            state.error[errorKey] = null;
        })
        .addCase(action.rejected, (state, action) => {
            state.loading[dataKey] = false;
            state.error[errorKey] = action.payload;
        });
};

const initialState = {
    // Data for each API
    SqHistory: null,
    SoHistory: null,
    HistoryItems:null,
    ReportData:null,
    history:null,

    // Dynamic loading and error states for each API
    loading: {
        SqHistory: false,
        SoHistory: false,
        HistoryItems:false,
        ReportData:false,
        history:false,
    },

    error: {
        SqHistoryError: null,
        SoHistoryError: null,
        HistoryItemsError:null,
        ReportDataError:null,
        historyError:null,
    },
};

export const HistoryReducer = createReducer(initialState, (builder) => {
    // Handle async actions using the utility function
    handleAsyncActions(builder, GetSQHistory, 'SqHistory', 'SqHistoryError');
    handleAsyncActions(builder, GetSOHistory, 'SoHistory', 'SoHistoryError');
    handleAsyncActions(builder, GetHistoryItems, 'HistoryItems', 'HistoryItemsError');
    handleAsyncActions(builder, PrintReport, 'ReportData', 'ReportDataError');
    handleAsyncActions(builder, GetHistory, 'history', 'historyError');

    
});

export default HistoryReducer;